import { IModalConfigSettings } from '@/uikit/components/AppModal/types';

export const defaultSettings: IModalConfigSettings = {
  title: '',
  text: '',
  isShowHeader: true,
  isShowFooter: false,
  isDraggable: true,
  isResize: false,
  size: {
    width: 'auto',
    height: 'auto',
    maxWidth: '90%',
    maxHeight: '90%',
    minWidth: 'auto',
    minHeight: '135px',
  },
};



// WEBPACK FOOTER //
// ./src/uikit/components/AppModal/defaultSettings.ts